import { assoc, compose, isEmpty, pick, pipe } from 'ramda'
import { formatApiDate } from '../../../../utils/helpers/date'
import { cleanRepliesForApi } from '../../../../utils/helpers/cleanRepliesRequest'
import { getRepliesFromCategories } from '../../../../utils/helpers/dynamicInputs'

const events = [
  {
    statusId: 8,
    eventDate: formatApiDate(new Date())
  },
  {
    statusId: 5,
    eventDate: formatApiDate(new Date())
  },
  {
    statusId: 1,
    eventDate: formatApiDate(new Date())
  }
]

export const cleanReplies = pipe(getRepliesFromCategories, cleanRepliesForApi, list =>
  isEmpty(list) ? undefined : list
)

export const cleanRequest = (executionForm, user, placeId, assetId, dynamicServiceOrder) => {
  return compose(
    pick([`name`, `checklistId`, `description`, `placeId`, 'assetId', `userId`, `events`, `replies`]),
    assoc(`name`, dynamicServiceOrder.name),
    assoc(`checklistId`, dynamicServiceOrder.checklistId),
    assoc(`description`, dynamicServiceOrder.description),
    assoc(`assetId`, assetId),
    assoc(`placeId`, typeof placeId === 'string' ? parseInt(placeId, 10) : placeId),
    assoc('userId', user?.id ?? null),
    assoc('events', events),
    item => assoc('replies', cleanReplies(executionForm), item)
  )()
}
